// src/pages/technicalAnalysis/utils/operationFlowProcessing.js

export const processOperationFlowData = (rawData) => {
    // Consolidate duplicate workflows by merging steps
    const consolidatedWorkflows = rawData.business_workflows.reduce((acc, workflow) => {
      const key = workflow.name;
      if (!acc[key]) {
        acc[key] = {
          ...workflow,
          implementations: [workflow.source_file]
        };
      } else {
        acc[key].steps = [...acc[key].steps, ...workflow.steps];
        acc[key].implementations.push(workflow.source_file);
      }
      return acc;
    }, {});
  
    // Group transaction patterns by type
    const consolidatedPatterns = rawData.transaction_patterns.reduce((acc, pattern) => {
      const key = `${pattern.consistency_scope}-${pattern.rollback_behavior}`;
      if (!acc[key]) {
        acc[key] = {
          ...pattern,
          sources: [pattern.source_file]
        };
      } else {
        acc[key].operations_sequence = [
          ...new Set([...acc[key].operations_sequence, ...pattern.operations_sequence])
        ];
        acc[key].sources.push(pattern.source_file);
      }
      return acc;
    }, {});
  
    // Consolidate API groupings
    const consolidatedApiGroups = rawData.api_groupings.reduce((acc, group) => {
      const key = group.group_name;
      if (!acc[key]) {
        acc[key] = {
          ...group,
          sources: [group.source_file]
        };
      } else {
        // Merge endpoints and ensure uniqueness
        const existingEndpoints = new Set(acc[key].endpoints.map(e => `${e.path}-${e.method}-${e.business_operation}`));
        const newEndpoints = group.endpoints.filter(e => 
          !existingEndpoints.has(`${e.path}-${e.method}-${e.business_operation}`)
        );
        acc[key].endpoints = [...acc[key].endpoints, ...newEndpoints];
        acc[key].sources.push(group.source_file);
      }
      return acc;
    }, {});
  
    return {
      workflows: Object.values(consolidatedWorkflows),
      patterns: Object.values(consolidatedPatterns),
      apiGroups: Object.values(consolidatedApiGroups)
    };
  };
  